import { render } from "./qnaModal.vue?vue&type=template&id=14427fa9&ts=true"
import script from "./qnaModal.vue?vue&type=script&lang=ts"
export * from "./qnaModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__